import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { showSnackBar } from "../../utils/commonServices";
import {  acceptRevisionApi, createInternalRevisionApi, createRevisionLogApi, deleteRevisionLogApi, getInternalRevisionDetailsApi, getInternalRevisionsListApi, getListOfEditingCyclesApi, getRevisionLogsListApi, rejectRevisionApi, sendToApproverApi, updateRevisionLogApi } from "../../services/api";
import { setTheme } from "../../redux/customThemeSlice";
import { getTheme } from "../whitelabel/actions";
import { updateProjectState } from "../../redux/projectSlice";
import { updateReviewState } from "../../redux/reviewSlice";
import { setSnackbar } from "../../redux/messageSlice";
import { updateState } from "../../redux/commonSlice";


export default ()=> {
 
  const dispatch = useDispatch();
  const commonReducer = useSelector(state=> state.root.commonReducer)
  
  const projectReducer = useSelector(state=> state.projectReducer)
  const reviewEventReducer = useSelector(state=> state.reviewEventReducer)
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const code = query.get('c')

  /////////////////---------------------------INTERNAL REVISON----------------------------/////////////////////
 
////////////////////GET get editing cycles list api  api/v1/internal_revisions/editing_cycles//////////////////////////

    const getEditingCyclesList = (payload, callback ) => {
      dispatch(updateReviewState({is_loading: true}))
      getListOfEditingCyclesApi(payload) 
      .then((response) => {
        dispatch(updateReviewState({is_loading: false}))
        if(response?.data?.http_code === 200){
          dispatch(updateReviewState({editing_cycles_list: response.data.data.editing_cycles, 
            user_revision: response.data.data.editing_cycles[0]?.revision ,
            editing_cycle_id: response.data.data.editing_cycles[0]?.id, 
            internal_revision_id:  response.data.data.editing_cycles[0]?.internal_revisions[response.data.data.editing_cycles[0]?.internal_revisions?.length - 1]?.id , 
            current_internal_revision:  response.data.data.editing_cycles[0]?.internal_revisions[response.data.data.editing_cycles[0]?.internal_revisions?.length - 1] , 
            selected_video_url:  response.data.data.editing_cycles[0]?.internal_revisions[response.data.data.editing_cycles[0]?.internal_revisions?.length - 1]?.video_url,
            internal_revisions_list:  response.data.data.editing_cycles[0]?.internal_revisions?.reverse(), 
          }))

          console.log(response.data.data.editing_cycles[0]?.internal_revisions[response.data.data.editing_cycles[0]?.internal_revisions?.length - 1],'88888888888888888888888888888888888')

          callback && response.data.data.editing_cycles[0]?.internal_revisions[0] && callback(response.data.data.editing_cycles[0]?.internal_revisions[0])
          
    
    
        
       }
      })
      .catch((error) => {
       if(error) {
        const errorObject = error?.response?.data;
        if(errorObject?.data){
          showSnackBar(dispatch, errorObject);
        } 
      }
      });
    }

    ////////////////////GET get internal revisions list api   api/v1/internal_revisions//////////////////////////

    const getInternalRevisionsList = (payload, callback ) => {
        dispatch(updateReviewState({is_loading: true}))
        getInternalRevisionsListApi(payload) 
        .then((response) => {
         dispatch(updateReviewState({is_loading: false}))
          if(response?.data?.http_code === 200){
           dispatch(updateReviewState({internal_revisions_list: response.data.data.internal_revisions}))
           console.log(response.data.data.internal_revisions)
           callback && callback()
         }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          if(errorObject.data){
            showSnackBar(dispatch, errorObject);
          } 
        }
        });
      }

  ////////////////////POST create internal revision api    api/v1/internal_revisions//////////////////////////

    const createInternalRevision = (values ,callback ) => {
        dispatch(updateReviewState({is_loading: true}))
          const payload = values   
      createInternalRevisionApi(payload) 
        .then((response) => {
          // console.log({response})
          dispatch(updateReviewState({is_loading: false}))
          if(response?.data?.http_code === 200){
            getInternalRevisionsList({event_id: payload?.editing_cycle_id})
            dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
            !!callback && callback()
          }
        })
        .catch((error) => {
            if(error) {
                const errorObject = error?.response?.data;
                if(errorObject.data){
                  showSnackBar(dispatch, errorObject);
                } 
              }
        //   dispatch(setSnackbar({type:'error', flag:true, message: error.response.data.message}))
        });
      }


    ////////////////////GET get internal revisions details api   api/v1/internal_revisions/:id//////////////////////////

    const getRevisionDetails = (payload, callback ) => {
      dispatch(updateReviewState({is_loading: true, revision_details_loading: true}))
      getInternalRevisionDetailsApi(payload) 
      .then((response) => {
       dispatch(updateReviewState({is_loading: false, revision_details_loading: false}))
        if(response?.data?.http_code === 200){
        //  dispatch(updateReviewState({internal_revision_details: response.data.data.editing_cycles}))
         console.log(response.data.data.editing_cycles)
         callback && callback(response?.data?.data?.editing_cycles)
       }
      })
      .catch((error) => {
        dispatch(updateReviewState({is_loading: false, revision_details_loading: false}))
       if(error) {
        const errorObject = error?.response?.data;
        if(errorObject.data){
          showSnackBar(dispatch, errorObject);
        } 
      }
      });
    }

    const rejectInternalRevision = (payload, callback ) => {
      dispatch(updateReviewState({is_loading: true}))
      rejectRevisionApi(payload) 
      .then((response) => {
       dispatch(updateReviewState({is_loading: false}))
        if(response?.data?.http_code === 200){
          getEditingCyclesList({event_id: commonReducer?.production_event_id, organisation_id:commonReducer?.selected_organisation?.id})
          dispatch(updateState({can_upload: true}))
          dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
        dispatch(updateReviewState({show_video_checklist: true}))
        //  console.log(response.data.data.message)
         callback && callback()
       }
      })
      .catch((error) => {
     
       if(error) {
    
        callback && callback()
        const errorObject = error?.response?.data;
        if(errorObject){
          showSnackBar(dispatch, errorObject);
        } 
      }
      });
    }

     
      


           /////////////GET accept internal revision api   api/v1/internal_revisions/accept_revision?id=24' ///////////////

           const acceptInternalRevision = (payload, callback ) => {
            dispatch(updateReviewState({accept_internal_revision_loading: true}))
            acceptRevisionApi(payload) 
            .then((response) => {
             dispatch(updateReviewState({accept_internal_revision_loading: false}))
              if(response?.data?.http_code === 200){
                getEditingCyclesList({event_id: commonReducer?.production_event_id, organisation_id:commonReducer?.selected_organisation?.id})
                dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
              // console.log(response.data.data.logs)
               callback && callback()
             }
            })
            .catch((error) => {
             if(error) {
              callback && callback()
              const errorObject = error?.response?.data;
              if(errorObject){
                showSnackBar(dispatch, errorObject);
              } 
            }
            });
          }



    /////////////////------------------------------LOGS----------------------------------///////////////////////


    ////////////////////POST create logs api    api/v1/logs//////////////////////////

      const createRevisionLog = (values ,callback ) => {
        dispatch(updateReviewState({is_loading: true}))
          const payload = values   
      createRevisionLogApi(payload) 
        .then((response) => {
          // console.log({response})
          dispatch(updateReviewState({is_loading: false}))
          if(response?.data?.http_code === 200){
            getRevisionLogsList({internal_revision_id: payload?.internal_revision_id})
            dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
            !!callback && callback()
          }
        })
        .catch((error) => {
            if(error) {
                const errorObject = error?.response?.data;
                if(errorObject.data){
                  showSnackBar(dispatch, errorObject);
                } 
              }
        //   dispatch(setSnackbar({type:'error', flag:true, message: error.response.data.message}))
        });
      }


       ////////////////////GET get logs list api   api/v1/logs?internal_revision_id=18//////////////////////////

       const getRevisionLogsList = (payload, callback ) => {
        dispatch(updateReviewState({is_loading: true}))
        getRevisionLogsListApi(payload) 
        .then((response) => {
         dispatch(updateReviewState({is_loading: false}))
          if(response?.data?.http_code === 200){
           dispatch(updateReviewState({selected_video_logs_list: response.data.data.logs}))
           console.log(response.data.data.logs)
           callback && callback()
         }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          if(errorObject.data){
            showSnackBar(dispatch, errorObject);
          } 
        }
        });
      }



    ///////////////////////PUT update revision log api        api/v1/logs/:id//////////////////////////

   const updateRevisionLog= (values ,callback, setSelectedRole, role ) => {
    dispatch(updateReviewState({is_loading:true}))  
    const payload = values
  updateRevisionLogApi(payload) 
    .then((response) => {
      // console.log({response})
      dispatch(updateReviewState({is_loading:false}))  
      if(response?.data?.http_code === 200){
        //   setSelectedRole(role?.name)
          getRevisionLogsList({internal_revision_id: reviewEventReducer?.internal_revision_id})
          dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
          !!callback && callback()
      }
    })
    .catch((error) => {
      dispatch(updateProjectState({is_loading:false}))  
      if(error) {
        const errorObject = error?.response?.data;
        if(errorObject.data){
          showSnackBar(dispatch, errorObject);
        } 
      }
    //   dispatch(setSnackbar({type:'error', flag:true, message: error?.response?.data?.message}))
    });
  }
  

//////////////////////////DELETE delete revision log api      api/v1/logs/:id ////////////////////////////

 const deleteRevsionLog = (values ,callback) => {
    const payload = values
    dispatch(updateReviewState({is_loading:true})) 
  deleteRevisionLogApi(payload) 
  .then((response) => {
    // console.log({response})
    dispatch(updateReviewState({is_loading:false})) 
    if(response?.data?.http_code === 200){
      getRevisionLogsList({internal_revision_id: reviewEventReducer?.internal_revision_id})
      dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
      !!callback && callback()
    }
  })
  .catch((error) => {
    dispatch(updateReviewState({is_loading:false})) 
    if(error) {
        const errorObject = error?.response?.data;
        if(errorObject.data){
          showSnackBar(dispatch, errorObject);
        } 
    }
    // dispatch(setSnackbar({type:'error', flag:true, message: error.response.data.message}))
  });
}


   ///////////////////////PUT send for approver api  api/v1/internal_revisions/:id/send_to_approver//////////////////////////

   const sendForApproval = (payload ,callback) => {
    dispatch(updateReviewState({sent_for_approval_loading:true}))  
   
  sendToApproverApi(payload) 
    .then((response) => {
      // console.log({response})
      // dispatch(updateReviewState({is_loading:false}))  
      dispatch(updateReviewState({sent_for_approval_loading: false}))
              if(response?.data?.http_code === 200){
                getEditingCyclesList({event_id: commonReducer?.production_event_id, organisation_id:commonReducer?.selected_organisation?.id})
                dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
              // console.log(response.data.data.logs)
               callback && callback()
             }
    })
    .catch((error) => {
      dispatch(updateReviewState({sent_for_approval_loading:false}))  
      if(error) {
        const errorObject = error?.response?.data;
        // console.log(errorObject, 'errorobject approver------------------------')
        if(errorObject){
          showSnackBar(dispatch, errorObject);
          callback && callback()
        } 
      }
    //   dispatch(setSnackbar({type:'error', flag:true, message: error?.response?.data?.message}))
    });
  }

     
    

  return {  
    getEditingCyclesList, 
    getInternalRevisionsList, 
    createInternalRevision, 
    getRevisionDetails, 
    createRevisionLog, 
    getRevisionLogsList, 
    updateRevisionLog, 
    deleteRevsionLog, 
    rejectInternalRevision,
    acceptInternalRevision,
    sendForApproval
  };
}